import React, { useState } from 'react';
import { InfoIcon, v2 } from '@fieldnation/platform-components';
import styles from './styles.scss';
import PartsProviderInputs from './PartsProviderInputs';
import { AdditionalPartField, PartsProviderInputsValue } from './types.d';
import {
  additionalPartFieldsToProviderInputs,
  providerInputsToAdditionalPartFields,
} from './utils';

const { Checkbox } = v2;

const DEFAULT_PROVIDER_INPUTS: PartsProviderInputsValue = {
  rmaNumber: false,
  serialNumber: false,
  internalNumber: false,
  internalNumberAlias: '',
};

interface Props {
  /** Currently configured provider-required fields, e.g. `work_order.parts.additional_part_fields`. */
  fields: AdditionalPartField[];
  onChange: (fields: AdditionalPartField[]) => void;
}

const PartsProviderSettings = ({ fields, onChange }: Props): JSX.Element => {
  const [providerInputs, setProviderInputs] = useState<PartsProviderInputsValue>(
    additionalPartFieldsToProviderInputs(fields),
  );
  // Independent of `fields` so the panel can stay open while every checkbox is unchecked.
  const [providerMustAddInfo, setProviderMustAddInfo] = useState(fields.length > 0);

  const handleProviderInputsChange = (nextInputs: PartsProviderInputsValue) => {
    setProviderInputs(nextInputs);
    onChange(providerInputsToAdditionalPartFields(nextInputs));
  };

  return (
    <div className={styles.settingsContainer}>
      <p className={styles.settingsLabel}>Settings</p>
      <div className={styles.settingOption}>
        <Checkbox
          id="providerMustAddInfo"
          onChange={(selected) => {
            const isChecked = selected?.includes?.('providerMustAddInfo') ?? false;
            setProviderMustAddInfo(isChecked);
            if (!isChecked) {
              handleProviderInputsChange({ ...DEFAULT_PROVIDER_INPUTS });
            }
          }}
          options={[{
            label: 'Provider must add additional info',
            value: 'providerMustAddInfo',
          }]}
          value={providerMustAddInfo ? ['providerMustAddInfo'] : []}
        />
        <InfoIcon>
          Require the assigned provider to submit additional identifiers for each part when entering part usage.
        </InfoIcon>
      </div>
      {providerMustAddInfo && (
        <PartsProviderInputs
          value={providerInputs}
          onChange={handleProviderInputsChange}
        />
      )}
    </div>
  );
};

export default PartsProviderSettings;
